
export const LOAD_ELEVATION_DATA_IN_PROGRESS = "LOAD_DATA_IN_PROGRESS";
export const loadElevationDataInProgress = () => ({
  type: LOAD_ELEVATION_DATA_IN_PROGRESS,
});

export const LOAD_ELEVATION_DATA_SUCCESS = "LOAD_DATA_SUCCESS";
export const loadElevationDataSuccess = (data) => ({
  type: LOAD_ELEVATION_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_CHANGE_ROLE_DATA_SUCCESS = "LOAD_CHANGE_ROLE_DATA_SUCCESS";
export const loadChangeRoleDataSuccess = (data) => ({
  type: LOAD_CHANGE_ROLE_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_CHANGE_PERMISSION_DATA_SUCCESS = "LOAD_CHANGE_PERMISSION_DATA_SUCCESS";
export const loadChangePermissionDataSuccess = (data) => ({
  type: LOAD_CHANGE_PERMISSION_DATA_SUCCESS,
  payload: { data },
});


export const LOAD_USER_PERMISSION_DATA_SUCCESS = "LOAD_USER_PERMISSION_DATA_SUCCESS";
export const loadUserPermissionDataSuccess = (data) => ({
  type: LOAD_USER_PERMISSION_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_ELEVATION_DATA_FAILURE = "LOAD_ELEVATION_DATA_FAILURE";
export const loadElevationDataFailure = (data) => ({
  type: LOAD_ELEVATION_DATA_FAILURE,
  payload: { data },
});

export const ELEVATION_OPERATION_COMPLETED = "ELEVATION_OPERATION_COMPLETED";
export const elevationOperationCompleted = () => ({
  type: ELEVATION_OPERATION_COMPLETED,
});

